<script setup lang="ts">
import type { CommandItemBaseProps } from "./types";
import { InlineCode } from "ls/common/keyboardShortcuts";
import { CodeIcon } from "lucide-vue-next";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps>();

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .setCode()
    .run();
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :icon="CodeIcon"
    :shortcut="InlineCode"
    @click="run"
    @keydown.enter="run"
  >
    Inline code
  </SuggestionListItem>
</template>
